// extracted by mini-css-extract-plugin
export default {"searchForm":"invoice-new-client-page_searchForm__ByhoI"};